import React from "react";
import logo from "./logo.svg";
import "./global.css";
import ProductsTableInstance from "./components/productsTableInstance";

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  return (
    <div className="App">
      <>
        <ProductsTableInstance id={id} />
      </>
    </div>
  );
}

export default App;
